import {Link} from '@primer/react'
import {SelectPanel} from '@primer/react/drafts'

export const SelectedLabelErrorMessage = ({title}: {title: string}) => (
  <SelectPanel.Message variant="error" size="full" title={title}>
    Try again or if the problem persists, <Link href="/support">contact support</Link>
  </SelectPanel.Message>
)

export const RepoLabelErrorMessage = () => (
  <SelectPanel.Message variant="error" size="inline">
    We couldn&apos;t load the labels. Try again or if the problem persists, <Link href="/support">contact support</Link>
  </SelectPanel.Message>
)

try{ SelectedLabelErrorMessage.displayName ||= 'SelectedLabelErrorMessage' } catch {}
try{ RepoLabelErrorMessage.displayName ||= 'RepoLabelErrorMessage' } catch {}